import { render } from "./Com_Play.vue?vue&type=template&id=740f405e&scoped=true"
import script from "./Com_Play.vue?vue&type=script&lang=js"
export * from "./Com_Play.vue?vue&type=script&lang=js"

import "./Com_Play.vue?vue&type=style&index=0&id=740f405e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740f405e"]])

export default __exports__